import { apiFetch } from './client';
import type {
  ContinuityActionRow,
  ContinuityActionStatus,
  ImpactIfLost,
  ImportInitialOKRsResult,
  OKRDetail,
  OKRListRow,
  OKRTaskOption,
  TimeToReplace
} from '$lib/types';

export interface OKRBody {
  name?: string;
  group?: string;
  description?: string;
  time_to_replace?: TimeToReplace;
  impact_if_lost?: ImpactIfLost;
}

export interface OKRAssignmentsBody {
  main_user_id?: number | null;
  backup_user_ids: number[];
  can_do_user_ids: number[];
}

export interface OKRProofTestBody {
  user_id: number;
  date: string;
  went_fine: boolean;
  notes?: string;
}

export interface ContinuityActionBody {
  description?: string;
  owner_id?: number;
  due_date?: string;
  status?: ContinuityActionStatus;
}

// okrsApi backs the Continuity module's OKR register — every route is
// admin-only server-side (see internal/api/handlers/okrs.go); the frontend
// just surfaces the 403.
export const okrsApi = {
  list: () => apiFetch<OKRListRow[]>('/admin/okrs'),
  // importInitial is Part B's one-time "Load starter register" action —
  // the server 409s unless the okrs table is completely empty.
  importInitial: () => apiFetch<ImportInitialOKRsResult>('/admin/okrs/import_initial', { method: 'POST' }),
  taskOptions: () => apiFetch<OKRTaskOption[]>('/admin/okrs/task_options'),
  get: (id: number) => apiFetch<OKRDetail>(`/admin/okrs/${id}`),
  create: (body: OKRBody) => apiFetch<OKRDetail>('/admin/okrs', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: OKRBody) =>
    apiFetch<OKRDetail>(`/admin/okrs/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  setAssignments: (id: number, body: OKRAssignmentsBody) =>
    apiFetch<OKRDetail>(`/admin/okrs/${id}/assignments`, { method: 'PUT', body: JSON.stringify(body) }),
  setTaskLinks: (id: number, taskIds: number[]) =>
    apiFetch<OKRDetail>(`/admin/okrs/${id}/task_links`, { method: 'PUT', body: JSON.stringify({ task_ids: taskIds }) }),
  recordProofTest: (id: number, body: OKRProofTestBody) =>
    apiFetch<OKRDetail>(`/admin/okrs/${id}/proof_tests`, { method: 'POST', body: JSON.stringify(body) }),
  createAction: (id: number, body: ContinuityActionBody) =>
    apiFetch<OKRDetail>(`/admin/okrs/${id}/actions`, { method: 'POST', body: JSON.stringify(body) }),
  updateAction: (actionId: number, body: ContinuityActionBody) =>
    apiFetch<ContinuityActionRow>(`/admin/okrs/actions/${actionId}`, { method: 'PATCH', body: JSON.stringify(body) })
};
